// Constantes para métodos de pago
export const PAYMENT_METHODS = {
  CASH: 'CASH',
  CARD: 'CARD',
  QR: 'QR',
  TRANSFER: 'TRANSFER',
  CHECK: 'CHECK',
} as const;

export const PAYMENT_METHOD_LABELS = {
  [PAYMENT_METHODS.CASH]: 'Efectivo',
  [PAYMENT_METHODS.CARD]: 'Tarjeta',
  [PAYMENT_METHODS.QR]: 'QR',
  [PAYMENT_METHODS.TRANSFER]: 'Transferencia',
  [PAYMENT_METHODS.CHECK]: 'Cheque',
} as const;

export const PAYMENT_METHOD_ICONS = {
  [PAYMENT_METHODS.CASH]: 'money',
  [PAYMENT_METHODS.CARD]: 'credit_card',
  [PAYMENT_METHODS.QR]: 'qr_code',
  [PAYMENT_METHODS.TRANSFER]: 'account_balance',
  [PAYMENT_METHODS.CHECK]: 'receipt',
} as const;

export const PAYMENT_STATUS = {
  PENDING: 'PENDING',
  COMPLETED: 'COMPLETED',
  FAILED: 'FAILED',
  CANCELLED: 'CANCELLED',
  REFUNDED: 'REFUNDED',
} as const;

export const PAYMENT_STATUS_LABELS = {
  [PAYMENT_STATUS.PENDING]: 'Pendiente',
  [PAYMENT_STATUS.COMPLETED]: 'Completado',
  [PAYMENT_STATUS.FAILED]: 'Fallido',
  [PAYMENT_STATUS.CANCELLED]: 'Cancelado',
  [PAYMENT_STATUS.REFUNDED]: 'Reembolsado',
} as const;

export const PAYMENT_STATUS_COLORS = {
  [PAYMENT_STATUS.PENDING]: 'warning',
  [PAYMENT_STATUS.COMPLETED]: 'success',
  [PAYMENT_STATUS.FAILED]: 'error',
  [PAYMENT_STATUS.CANCELLED]: 'error',
  [PAYMENT_STATUS.REFUNDED]: 'info',
} as const;

export const PAYMENT_TYPES = {
  FULL: 'FULL',
  PARTIAL: 'PARTIAL',
  INSTALLMENT: 'INSTALLMENT',
} as const;

export const PAYMENT_TYPE_LABELS = {
  [PAYMENT_TYPES.FULL]: 'Pago Completo',
  [PAYMENT_TYPES.PARTIAL]: 'Pago Parcial',
  [PAYMENT_TYPES.INSTALLMENT]: 'Pago a Cuotas',
} as const;

export const CURRENCY = {
  VES: 'VES',
  USD: 'USD',
  EUR: 'EUR',
} as const;

export const CURRENCY_SYMBOLS = {
  [CURRENCY.VES]: 'Bs',
  /** Evitar símbolo $ en UI; usar código si se muestra USD */
  [CURRENCY.USD]: 'USD',
  [CURRENCY.EUR]: '€',
} as const;

export const CURRENCY_LABELS = {
  [CURRENCY.VES]: 'Bolívar Venezolano',
  [CURRENCY.USD]: 'Dólar Estadounidense',
  [CURRENCY.EUR]: 'Euro',
} as const;
